import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '../util'
import { Api } from '@cruz-com/lookup'

export async function getFilterOption(params: object, category?: string): Promise<any> {
  try {
    const res = await fetch(`${baseURL}/vehicle/filter-option${category ? `/${category}` : ''}?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 3 }
    })
    const d: Api.Result<any> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}